import { render, staticRenderFns } from "./matchComponent.vue?vue&type=template&id=2fe1f982&scoped=true&"
import script from "./matchComponent.vue?vue&type=script&lang=js&"
export * from "./matchComponent.vue?vue&type=script&lang=js&"
import style0 from "./matchComponent.vue?vue&type=style&index=0&id=2fe1f982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1f982",
  null
  
)

export default component.exports